/**
 * insuranceRequestMessage.js
 * Mensagem pronta para pedir à pessoa atendida o documento do convênio que só
 * ela tem (pedido médico, carteirinha). Guia é com a operadora, nunca entra aqui;
 * "falta vincular" também não, porque o documento já está na ficha.
 */

import { describeReservationSlot } from './reservationMessage';

// Código do aviso (InsurancePendencies.php) → o que pedir
const ASK_ITEMS = {
  request_missing: 'request',
  request_expired: 'request',
  request_expiring: 'request',
  card_inactive: 'card',
  card_expired: 'card',
  card_expiring: 'card',
};

const ITEM_TEXT = {
  request: 'pedido médico atualizado',
  card: 'foto da carteirinha do convênio dentro da validade',
};

/** O que dá para pedir à pessoa a partir dos avisos ('request', 'card'), sem repetir. */
export function askableItems(alerts) {
  const items = [];
  (alerts || []).forEach((alert) => {
    const item = ASK_ITEMS[alert?.code];
    if (item && !items.includes(item)) items.push(item);
  });
  return items;
}

/**
 * @param {Object} p
 * @param {string} p.companyName
 * @param {string} p.personName
 * @param {string} p.date - "YYYY-MM-DD HH:MM:SS"
 * @param {string} p.providerName
 * @param {string[]} p.items - de askableItems()
 */
export function buildInsuranceRequestMessage({ companyName, personName, date, providerName, items }) {
  const header = companyName ? `*${companyName}*\n\n` : '';
  const firstName = String(personName || '').trim().split(/\s+/)[0] || '';
  const greeting = firstName ? `Olá, ${firstName}, tudo bem?` : 'Olá, tudo bem?';
  const by = providerName ? ` pelo ${providerName}` : '';
  const when = date ? `, marcado para ${describeReservationSlot(date)}` : '';
  const list = items.map((item) => `- ${ITEM_TEXT[item]}`).join('\n');
  return `${header}${greeting}\n\nPara o seu atendimento${by}${when}, precisamos de:\n${list}\n\nPode enviar uma foto por aqui antes do atendimento? Obrigado.`;
}
